module.exports = __webpack_public_path__ + "img/msc.ec52ad65.png";